export default {
      id: "icon-moustache-usage",
      viewBox: "0 0 110.1 56.8",
      url: __webpack_public_path__ + "icons.svg#icon-moustache",
      toString: function () {
        return this.url;
      }
    }